module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "top-wrap"
  }, [_c('div', {
    staticClass: "center-wrap"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('a', {
    staticClass: "logo-wrap",
    attrs: {
      "href": _vm.winPageData.index_page
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "//zkres.myzaker.com/static/rmt/logo.png",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "合作方式"
    }
  }, [_vm._v("合作方式")]), _vm._v(" "), (_vm.winPageData.user_info) ? _c('a', {
    staticClass: "user",
    attrs: {
      "href": _vm.winPageData.myorg_page
    }
  }, [_vm._v("进入后台")]) : _c('a', {
    attrs: {
      "href": _vm.winPageData.login_page,
      "title": "登录"
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "block-wrap block-1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("核心产品")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b1),
      expression: "picPath.b1",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("云服务超市，可自主挑选、搭配产品和服务")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              从舆情监测、指挥调度，到全媒体内容生产、审核、分发、统计、考核、版权管理，再到经营服务、平台建设、可视化等，进行集约建设、模块化输出，并有专门团队进行定期升级、运维支持和长期培训服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("行业地位")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b2),
      expression: "picPath.b2",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("国内媒体融合第三条路径的创造者")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              在“内容、渠道、平台、经营、管理”全领域与主流媒体深度融合，用跨区域、跨介质、跨产业的融合发展，为传媒产业的转型升级打开了想象空间。")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("合作优势")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b3),
      expression: "picPath.b3",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("‌‌资深团队深耕国内领先资讯平台ZAKER近九年\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              出色的开发团队、前沿的核心技术，更理解媒体行业、更了解媒体运营，对新闻行业、媒体融合具备更长远的规划和运营支撑。")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("主要伙伴")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b4),
      expression: "picPath.b4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("已与各省市主流媒体合作4年")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              已与“现代快报、潇湘晨报、新快报、新文化报、兰州日报、贵阳日报、南宁日报、辽沈晚报、新晚报、合肥晚报”等近30家主流媒体进行了合作。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap live",
    attrs: {
      "data-sec": "0",
      "data-third": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.live_icon),
      expression: "picPath.live_icon",
      arg: "background-image"
    }],
    staticClass: "icon lazy"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("直播套件")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("权威、轻量化移动PGC直播生产管理平台")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.live),
      expression: "picPath.live",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("\n              多种终端、多机位超强映像表现能力：完美支持手机、无人机、摄像机、监控设备、VR摄像机等各种摄像设备，及推拉流适配。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.live5),
      expression: "picPath.live5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("直播管理平台")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("\n              高直播用户观看体验：重要信息以文字、图片（静态/Gif）等形式进行补充，背景音乐添加、预告片预热、用户评论互动和管理等；\n              二次传播效果优化：回看下载剪辑，直播数据统计分析。\n            ")])])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c1),
      expression: "picPath.c1",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("贵阳晚报《伙食团》1期/周")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("以贵阳市、贵州省范围的餐饮题材内容为主要对象，推荐美食，分享美味，聚集吃货。")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c2),
      expression: "picPath.c2",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("合肥晚报《萌娃学堂》1期/周")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("一档集幽默、生活、寓教于乐三位一体的亲子节目，旨在通过孩子和主持人的互动协作，展现当代年轻父母和孩子们的交流方式。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap hsm",
    attrs: {
      "data-sec": "0",
      "data-third": "1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.hsm_icon),
      expression: "picPath.hsm_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("红树莓")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("更安全、高效的移动短视频采编审发工具")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.hsm),
      expression: "picPath.hsm",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("免费使用")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击获取下载方式和相关文档")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c3),
      expression: "picPath.c3",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("贵阳晚报《Z视频》记录型视频")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c4),
      expression: "picPath.c4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("新晚报《冰城5分熟》记录型视频")]), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap ai",
    attrs: {
      "data-sec": "0",
      "data-third": "2"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.ai_icon),
      expression: "picPath.ai_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("AI语音合成")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle bold"
  }, [_vm._v("\n          国内首家专注应用前沿人工智能语音合成技术于内容报道形态创新的平台。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.ai),
      expression: "picPath.ai",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c5),
      expression: "picPath.c5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("新快报《新新播报》1期/天")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("以智能语音播报前天及当天广东地区的重要新闻。")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c6),
      expression: "picPath.c6",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("现代快报《知了新闻》1期/天")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("一档日常早间新闻播报类栏目。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap vr",
    attrs: {
      "data-sec": "0",
      "data-third": "3"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.vr_icon),
      expression: "picPath.vr_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("威芽")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("\n          “带你进入新闻现场”的沉浸式VR全景新闻生产工具\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.vr),
      expression: "picPath.vr",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "block-title sm"
  }, [_vm._v("全景+新闻")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          把实地场景转化为可视化内容，把新闻第一现场立体化呈现，增强用户与新闻现场联结。从“看新闻”到“带你进入新闻现场”，给用户更直观、动态的理解。适用于大会报道、演唱会、体育赛事、突发现场、景区导览等等场景。 ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("免费使用")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击获取下载方式和相关文档")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c7),
      expression: "picPath.c7",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("现代快报")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("《VR全景 | 江苏省政协十二届一次会议开幕》")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c8),
      expression: "picPath.c8",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("今日消费")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("《全景VR+视频看房大集合》")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap h5",
    attrs: {
      "data-sec": "0",
      "data-third": "4"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.h5_icon),
      expression: "picPath.h5_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("H5平台")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.h5),
      expression: "picPath.h5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c9),
      expression: "picPath.c9",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("演示")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c10),
      expression: "picPath.c10",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("抽奖")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c11),
      expression: "picPath.c11",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("问卷、测试")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c12),
      expression: "picPath.c12",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("投票")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c13),
      expression: "picPath.c13",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("表单")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap design",
    attrs: {
      "data-sec": "0",
      "data-third": "5"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.design_icon),
      expression: "picPath.design_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("云设计")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("前沿视觉效果的轻量化美编工具")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.design),
      expression: "picPath.design",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab12",
    attrs: {
      "data-sec": "1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("全媒体指挥调度平台")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          集“媒资管理、策采编发审、指挥调度”于一体，PC端与移动端配合的平台。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab12),
      expression: "picPath.tab12",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab2",
    attrs: {
      "data-sec": "2"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("内容安全三审系统")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          共享ZAKER现有的安全防控体系，包括敏感内容智能识别预警、评论管理系统、反黑客攻击、账号管理系统等，通过移动端实现实时提交、实时审核，高效便捷。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.nrss),
      expression: "picPath.nrss",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab6",
    attrs: {
      "data-sec": "3"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("全媒体舆情监控系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab61),
      expression: "picPath.tab61",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("全网信息监测")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("采集监测“网站、微信、微博、客户端、纸媒”等全网信息")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab62),
      expression: "picPath.tab62",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("热点发现")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("分析全网热点和舆论发展趋势，掌握地方重点事件，预测、发现热点走势，为内容生产提供指导。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab65),
      expression: "picPath.tab65",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("舆情预警")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("实时舆情预警，后台、电话、短信警报")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab63),
      expression: "picPath.tab63",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("舆情报告")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("舆情日报，月报，季度报，年报")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab64),
      expression: "picPath.tab64",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("事件回溯")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("事件（领导、专题、政情等）定向监测，回溯分析报告")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab66),
      expression: "picPath.tab66",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("方案设置")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("针对特定“事件”自主设置舆情预警及监测方案，实时预测热点、舆情事件发生的可能性")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab4",
    attrs: {
      "data-sec": "4"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("内容管理平台")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab4),
      expression: "picPath.tab4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab5",
    attrs: {
      "data-sec": "5"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("用户管理系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab51),
      expression: "picPath.tab51",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("用户分级管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("按照用户活跃度、贡献度将用户进行划分，重点做好核心用户高价值用户的关系维护。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab52),
      expression: "picPath.tab52",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("用户安全管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("对用户平台账号、昵称、头像、评论、发帖、扰乱平台秩序等进行管理。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab53),
      expression: "picPath.tab53",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("用户行为统计")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("建立数据模型，分析用户行为，即阅读习惯及喜好，提升媒体社会影响力。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab3",
    attrs: {
      "data-sec": "6"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("融合发布系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab31),
      expression: "picPath.tab31",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("系统对接")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("系统接口对接，包含不限于：APP、双微、网站、新旧系统等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab32),
      expression: "picPath.tab32",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("一键分发")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("实现一体策划、一次采集、多种生成、一键分发，多元传播的建设理念。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab15",
    attrs: {
      "data-sec": "7"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("可视化呈现")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab15),
      expression: "picPath.tab15",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          支持多种业务数据信息的可视化呈现，包括互联网汇聚数据、报题或选题数据、生产或发布的内容数据、新闻生产流程状态数据、指挥调度信息、新闻传播影响力结果等。\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab13",
    attrs: {
      "data-sec": "8"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("绩效统计系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab131),
      expression: "picPath.tab131",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("多维考核")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("支持结合具体的绩效管理统计办法进行绩效考核统计设定，如：发稿数、转发数、评论数、观看量、价值性、影响力等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab132),
      expression: "picPath.tab132",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("数据导出")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("可以按人员、按时段、按类型等分类一键导出。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab10",
    attrs: {
      "data-sec": "9"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("广告投放系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab102),
      expression: "picPath.tab102",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("排期系统")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("对计划投放、已投放的广告进行点位、排期管理。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab103),
      expression: "picPath.tab103",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("广告类型")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("支持CPD、CPC、CPM、创意广告、内容定制型广告产品样式等。")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab101),
      expression: "picPath.tab101",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("广告上线")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("对广告素材进行内测、预览、上线操作。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab104),
      expression: "picPath.tab104",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("数据统计")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("含广告曝光、点击数据查看。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab11",
    attrs: {
      "data-sec": "10"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("营销服务平台")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab111),
      expression: "picPath.tab111",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("案例共享")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("平台月度、季度、年度项目规划及联动征集。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab113),
      expression: "picPath.tab113",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("专家智库")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("构建各行业专家智库，输出行业报告，专业辅助决策。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab112),
      expression: "picPath.tab112",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("策略支持")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("从每个节点的招商方案输出、个案辅助制作，到跨城市商业案例复制再造；从各类营销玩法教授，到运用数据做结案分析。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab114),
      expression: "picPath.tab114",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("传播资源")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("综合线上线下全网覆盖、跨媒体跨城市联动传播，从渠道资源到创意广告、到内容产品，合作超越资源本身。")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block one"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c14),
      expression: "picPath.c14",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab9",
    attrs: {
      "data-sec": "11"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("政务号服务")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab9),
      expression: "picPath.tab9",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          为政府部门提供政务号运营，推进政务公开、优化政务服务、凝聚社会共识、创新社会治理。\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab7",
    attrs: {
      "data-sec": "12"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("APP搭建")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab7),
      expression: "picPath.tab7",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab8",
    attrs: {
      "data-sec": "13"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("小程序开发")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab81),
      expression: "picPath.tab81",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("Saas平台")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("集成多个功能模板，快速生成如垂直资讯、政务发布、民生服务等不同业务场景小程序。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab82),
      expression: "picPath.tab82",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("小程序")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("以微信的社交场景为依托，打造如“权威养生图文资讯”、“经济民生语音播报”等多形态、易传播的社交资讯阵地。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab14",
    attrs: {
      "data-sec": "14"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("内容共享及版权管理系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab141),
      expression: "picPath.tab141",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("版权代理")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("支持原创认定，为授权的版权方提供线上线下版权交易、内容共享代理等服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab142),
      expression: "picPath.tab142",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("维权服务")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("用非诉、诉讼手段帮助媒体提升版权品牌价值，提高媒体版权变现收益。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab143),
      expression: "picPath.tab143",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("网页存证")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("与公证处合作的原创电子公证服务，存证“实时高效，公正、权威、价格便宜”。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab144),
      expression: "picPath.tab144",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("转载分析")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("提供原创稿件全网的实时传播路径，稿件转载明细，媒体转载详情。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab145),
      expression: "picPath.tab145",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("侵权预警")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("及时报告乙方侵权行为，并规避自身“非法”转载。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab146),
      expression: "picPath.tab146",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("律师联盟")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("提供专业律师属地化服务，提供跨区域媒体版权服务支持。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab147),
      expression: "picPath.tab147",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("在线交易")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("线上图片、视频素材上传到平台审核通过后，综合定价，在线交易管理。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  })])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "block-wrap cooper-media"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "cooper-title"
  }, [_vm._v("合作媒体")]), _vm._v(" "), _c('h3', {
    staticClass: "cooper-subtitle"
  }, [_vm._v("融媒体合作伙伴")]), _vm._v(" "), _c('div', {
    staticClass: "cooper-content clearfix"
  }, [_c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://wb.sznews.com/PC/layout/201908/27/node_A01.html",
      "title": "深圳晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            深圳晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic1),
      expression: "picPath.cooper.pic1",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.jnds.com.cn/",
      "title": "江南都市报",
      "target": "_blank"
    }
  }, [_vm._v("\n            江南都市报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic2),
      expression: "picPath.cooper.pic2",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "https://www.dahe.cn/",
      "title": "今日消费",
      "target": "_blank"
    }
  }, [_vm._v("\n            今日消费\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic3),
      expression: "picPath.cooper.pic3",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://xdkb.net/",
      "title": "现代快报",
      "target": "_blank"
    }
  }, [_vm._v("\n            现代快报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic4),
      expression: "picPath.cooper.pic4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.nnnews.net/",
      "title": "南宁晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            南宁晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic5),
      expression: "picPath.cooper.pic5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.xkb.com.cn/",
      "title": "新快报",
      "target": "_blank"
    }
  }, [_vm._v("\n            新快报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic6),
      expression: "picPath.cooper.pic6",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.hf365.com/",
      "title": "合肥晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            合肥晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic7),
      expression: "picPath.cooper.pic7",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.lnd.com.cn/",
      "title": "辽沈晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            辽沈晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic8),
      expression: "picPath.cooper.pic8",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://epaper.heyuan.cn/html/2019-08/27/node_1.htm",
      "title": "河源日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            河源日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic9),
      expression: "picPath.cooper.pic9",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.gywb.cn/",
      "title": "贵阳晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            贵阳晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic10),
      expression: "picPath.cooper.pic10",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.sjzdaily.com.cn/",
      "title": "燕赵晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            燕赵晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic11),
      expression: "picPath.cooper.pic11",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.sunnews.cn/",
      "title": "海西晨报",
      "target": "_blank"
    }
  }, [_vm._v("\n            海西晨报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic12),
      expression: "picPath.cooper.pic12",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.hilizi.com/",
      "title": "半岛晨报",
      "target": "_blank"
    }
  }, [_vm._v("\n            半岛晨报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic13),
      expression: "picPath.cooper.pic13",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.qhdnews.com/",
      "title": "秦皇岛日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            秦皇岛日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic14),
      expression: "picPath.cooper.pic14",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.lzbs.com.cn/",
      "title": "兰州日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            兰州日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic15),
      expression: "picPath.cooper.pic15",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.my399.com/",
      "title": "新晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            新晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic16),
      expression: "picPath.cooper.pic16",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.bdall.com/",
      "title": "保定晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            保定晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic17),
      expression: "picPath.cooper.pic17",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.xxcb.cn/",
      "title": "潇湘晨报",
      "target": "_blank"
    }
  }, [_vm._v("\n            潇湘晨报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic18),
      expression: "picPath.cooper.pic18",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.taiandaily.com.cn/",
      "title": "泰安日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            泰安日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic19),
      expression: "picPath.cooper.pic19",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "#",
      "title": "",
      "target": "_blank"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic20),
      expression: "picPath.cooper.pic20",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "#",
      "title": "",
      "target": "_blank"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic21),
      expression: "picPath.cooper.pic21",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.xwh.cn/",
      "title": "新文化报",
      "target": "_blank"
    }
  }, [_vm._v("\n            新文化报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic22),
      expression: "picPath.cooper.pic22",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "#",
      "title": "",
      "target": "_blank"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic23),
      expression: "picPath.cooper.pic23",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.ycwb.com/",
      "title": "羊城晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            羊城晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic24),
      expression: "picPath.cooper.pic24",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_footer",
    attrs: {
      "id": "wrap_footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "footer_inner"
    }
  }, [_c('span', [_vm._v("Copyright © 2011-2019 ZAKER.All Rights Reserved")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.miibeian.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备12019658号-1")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  "), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ1.jpg",
      "target": "_blank"
    }
  }, [_vm._v("ICP证粤B2-20130159")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  网络出版服务许可证："), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ3.jpg",
      "target": "_blank"
    }
  }, [_vm._v("（总）网出证（粤）字第050号")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  "), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ2_.jpg",
      "target": "_blank"
    }
  }, [_vm._v("增值电信业务经营许可证B2-20150871")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer3"
    }
  }), _vm._v("\n      网络文化经营许可证："), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ1.jpg",
      "target": "_blank"
    }
  }, [_vm._v("粤网文[2018]6864-2439号")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  法律邮箱：law@myzaker.com  "), _c('font', {
    attrs: {
      "color": "#ff5050"
    }
  }, [_vm._v("/")]), _vm._v("  "), _vm._m(18), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer4"
    }
  }), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20)], 1)]), _vm._v(" "), _c('r-login')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed-nav-wrap",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "fixed-nav-bar"
  }, [_c('div', {
    staticClass: "fixed-nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav-wrap"
  }, [_c('div', {
    staticClass: "sub-nav-list"
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;",
      "data-cls": "live"
    }
  }, [_vm._v("直播套件")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "hsm"
    }
  }, [_vm._v("红树莓 - 短视频")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "ai"
    }
  }, [_vm._v("AI 语音合成")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "vr"
    }
  }, [_vm._v("VR 全景")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "h5"
    }
  }, [_vm._v("H5 平台")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "design"
    }
  }, [_vm._v("云设计")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("全媒体生产工具")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("指挥调度")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("安全审核")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("舆情监控")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("内容管理")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("融合发布")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("可视化")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("绩效统计")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("广告投放")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("营销平台")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("政务服务")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("App搭建")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("小程序开发")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("版权管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-wrap"
  }, [_c('div', {
    staticClass: "banner-inner"
  }, [_c('h2', {
    staticClass: "banner-title"
  }, [_vm._v("媒体融合业务的云服务超市")]), _vm._v(" "), _c('h3', {
    staticClass: "banner-subtitle"
  }, [_vm._v("深耕媒体融合实践4年，整合搭建新型媒体业务平台，"), _c('br'), _vm._v("6套生产工具、7大融媒体系统、3大生产管理平台、2个发布端口、1套政务服务体系，"), _c('br'), _vm._v("为媒体融合全领域赋能增效。")]), _vm._v(" "), _c('img', {
    staticClass: "banner lazy",
    attrs: {
      "src": "//zkres.myzaker.com/static/rmt/banner.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "block-title block-content-column-title"
  }, [_vm._v("LIVE直播现场"), _c('span', {
    staticClass: "cha"
  }), _vm._v("导播")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("移动采编")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("具备远程回传、素材快速剪辑、图片合成视频、智能语音适配、人脸识别马赛克、背景音乐穿插等移动生产功能。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("三审机制")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("随时随地响应“内容批复”，方便快捷的流程实现移动指挥调度。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("多平台分发")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("通过采编后台发布至目标渠道，如自身新闻APP，或者绑定的第三方平台：腾讯 、优酷 、双微等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("溶洞篮球场、百年戴公馆、挥拳吧小汤圆"), _c('br'), _vm._v("已发布3期。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("记录冰城人民风情、城市面貌"), _c('br'), _vm._v("已发布10期。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("多语言多音色")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("提供基础男声、女声发音，支持变调，中文、英文、中英文混读合成，支持背景音乐添加，陆续推出更多特色发音功能。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("方便快捷的集成方式")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("简单易操作，节省融媒体人力，引领行业尖端技术潮流，探索全新的内容报道形式。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("丰富的场景应用")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("特色人工智能语音播报，可运用在媒体的日常业务中，满足用户在不同场景下获取资讯的需求。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("\n          用户运营、商业互动场景下的H5制作工具"), _c('br'), _vm._v(" 含“表单、投票、测验、问卷、演示、抽奖”，满足县级融媒体日常运营需求。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "block-h5-table"
  }, [_c('tr', [_c('td', [_vm._v("表单")]), _vm._v(" "), _c('td', [_vm._v("用户报名、信息收集等功能。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("报名+投票")]), _vm._v(" "), _c('td', [_vm._v("用在投票评选类活动的开展。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("问卷、测验")]), _vm._v(" "), _c('td', [_vm._v("可用在趣味问答、问答比赛、创意用户互动策划等。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("抽奖")]), _vm._v(" "), _c('td', [_vm._v("包括大转盘、刮刮乐、老虎机等趣味互动形式，可以配合拉新活动使用，通过抽奖刺激用户参与活动、下载客户端。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-box"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          可以通过此后台有效地进行图片编辑工作，云后台功能包括上传各种图片素材"), _c('br'), _vm._v("\n          和数据图表、输入文字、选择模板、设置背景样式等。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("远程回传模块")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持移动终端设备采集的文字、图片、音频、视频内容等各类型文件远程回传和回传文件管理等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("素材管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持文字、图片、音频、视频等不同类型外采资源的采集或导入，部门素材库浏览、挑选等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("选题提交-审核流程")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("选题创建和编辑、选题筛选、选题审核派发、组合报道等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("指挥调度")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("任务创建、指派、确认、状态查询、即时通讯等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("报提审核")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持选题移动审核、派发。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("发布审核")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("发布渠道的发布前、发布后内容进行三级审核流程。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("安全防控")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("包括敏感内容人工智能识别预警、评论分级管理系统、反黑客攻击、审核人员工作日志、统计报表等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("内容管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("全媒体数字资料的存储管理、检索及再利用，包括资源“入库、管理、检索、展现、出库、分级存储”等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("内容编辑")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持新闻稿件的多级审核、编辑、选用、推送、分享等功能。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("数据分析")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持对用户点击、转发、评论等数据的采集，频道发稿情况的统计，编辑/记者发稿情况的统计。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("新晚报")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("\n                  2018年ZAKER哈尔滨旅发委全案营销。借助线上线下、跨城市传播，项目总曝光量达9400余万。其中："), _c('br'), _vm._v("\n                  ·《行行摄摄大美冰城》更是成为推介旅游、营销城市的经典案例；"), _c('br'), _vm._v("\n                  ·《旅发大会》，霸屏式宣传报道，向全国范围更多的目标潜在客户展示了强大的内容生产能力、技术运用能力、全媒体推广能力。\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          具备内容聚合自媒体/政务号订阅体系、兴趣推荐算法、视听（直播、点播）体系、生活服务板块体系、个人主页用户管理体系。"), _c('br'), _vm._v("\n          支持文、图、视频、直播、VR、H5等内容发布。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-wrap cooper-type"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "cooper-title"
  }, [_vm._v("合作方式")]), _vm._v(" "), _c('h3', {
    staticClass: "cooper-subtitle"
  }, [_vm._v("全媒体内容生产工具，开通账号即可使用，一站式服务、一秒上手、快速发布，"), _c('br'), _vm._v("轻便灵活，成本更低。")]), _vm._v(" "), _c('div', {
    staticClass: "cooper-content"
  }, [_c('div', {
    staticClass: "cooper-block"
  }, [_c('div', {
    staticClass: "cooper-block-title"
  }, [_vm._v("体验版")]), _vm._v(" "), _c('p', {
    staticClass: "cooper-block-text"
  }, [_vm._v("\n              申请一个测试账号，一键登录体验系列产品。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "cooper-block"
  }, [_c('div', {
    staticClass: "cooper-block-title"
  }, [_vm._v("专业版")]), _vm._v(" "), _c('p', {
    staticClass: "cooper-block-text"
  }, [_vm._v("\n              服务包含但不限于：云服务、账号体系、数据管理等。更多融媒体产品、服务解决方案，可沟通定制\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cooper-bottom"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("更多项目合作 商务咨询")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("020-38488576 / 13570964521 "), _c('br'), _vm._v("\n            lifenni@myzaker.com\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602001315"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin": "0 5px 0 0"
    },
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/ga.png"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline",
      "color": "#939393"
    }
  }, [_vm._v("粤公网安备 44010602001315号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.gzaic.gov.cn/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "bottomimg",
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.gzjd.gov.cn/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "bottomimg",
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/2.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3078ce52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/index/pages/index.vue
// module id = 829
// module chunks = 9